"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M7.7 4.4a3.3 3.3 0 0 0-3.3 3.3v.15a.7.7 0 1 1-1.4 0V7.7A4.7 4.7 0 0 1 7.7 3h.15a.7.7 0 1 1 0 1.4zm7.75-.7a.7.7 0 0 1 .7-.7h.15A4.7 4.7 0 0 1 21 7.7v.15a.7.7 0 1 1-1.4 0V7.7a3.3 3.3 0 0 0-3.3-3.3h-.15a.7.7 0 0 1-.7-.7M3.7 15.45a.7.7 0 0 1 .7.7v.15a3.3 3.3 0 0 0 3.3 3.3h.15a.7.7 0 1 1 0 1.4H7.7A4.7 4.7 0 0 1 3 16.3v-.15a.7.7 0 0 1 .7-.7m16.6 0a.7.7 0 0 1 .7.7v.15a4.7 4.7 0 0 1-4.7 4.7h-.15a.7.7 0 1 1 0-1.4h.15a3.3 3.3 0 0 0 3.3-3.3v-.15a.7.7 0 0 1 .7-.7",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M5.55 8.25a2.7 2.7 0 0 1 2.7-2.7h7.5a2.7 2.7 0 0 1 2.7 2.7v7.5a2.7 2.7 0 0 1-2.7 2.7h-7.5a2.7 2.7 0 0 1-2.7-2.7zm2.7-1.3a1.3 1.3 0 0 0-1.3 1.3v7.5a1.3 1.3 0 0 0 1.3 1.3h7.5a1.3 1.3 0 0 0 1.3-1.3v-7.5a1.3 1.3 0 0 0-1.3-1.3z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M8.892 13.72c-.935.22-1.67.535-2.137.906l-.872-1.095c.694-.553 1.656-.93 2.689-1.173 1.044-.245 2.216-.365 3.38-.365 1.162 0 2.335.12 3.379.365 1.033.242 1.995.62 2.689 1.173l-.872 1.095c-.466-.371-1.203-.686-2.137-.905-.923-.217-1.986-.328-3.06-.328-1.073 0-2.136.111-3.06.328",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M10.413 9.696a.814.814 0 1 1-1.627 0 .814.814 0 0 1 1.627 0"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=CoverPhotoIcon24.js.map